import React from 'react';
import EcoImg from 'eco-design/base/eco-img';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

const UsageScenariosD = () => {
    const { t } = useLang('Delta3MaxSeriesStation.UsageScenariosD');
    return (
        <section className={`${styles.UsageScenariosD} GtmModuleData-section`} id="UsageScenariosD" data-section-id={'UsageScenariosD'}>
            <EcoImg
                isOpenLazy
                pc="https://websiteoss.ecoflow.com/upload/image/1762224179138/top%20center%20(1).jpg"
                pad="https://websiteoss.ecoflow.com/upload/image/1757386266172/used-bg-4-m.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1757386266172/used-bg-4-m.jpg"
            />
            <div className="sub-text">
                <p className="title">{t('title')}</p>
                <p className="sub-title">{t('subTitle')}</p>
            </div>
        </section>
    );
};

export default UsageScenariosD;
